/* SoraKsa theme behaviour: campaign carousel, product gallery, variants, cart. */
(function () {
  'use strict';

  /* ---------- campaign hero carousel ---------- */

  function initHero(hero) {
    var track = hero.querySelector('[data-hero-track]');
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    if (!track || slides.length < 2) return;

    var index = 0;
    var timer = null;
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 4000;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(next) {
      index = (next + slides.length) % slides.length;
      track.style.transform = 'translate3d(-' + index * 100 + '%,0,0)';
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        if (i === index) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function schedule() {
      if (!autoplay || reduced) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        go(index + 1);
        schedule();
      }, interval);
    }

    hero.addEventListener('click', function (event) {
      var el = event.target.closest('[data-hero-prev],[data-hero-next],[data-hero-dot]');
      if (!el) return;
      if (el.hasAttribute('data-hero-prev')) go(index - 1);
      else if (el.hasAttribute('data-hero-next')) go(index + 1);
      else go(Number(el.getAttribute('data-hero-dot')));
      schedule();
    });

    hero.addEventListener('mouseenter', function () {
      clearTimeout(timer);
    });
    hero.addEventListener('mouseleave', schedule);

    go(0);
    schedule();
  }

  document.querySelectorAll('[data-campaign-hero]').forEach(initHero);

  /* ---------- product gallery ---------- */

  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main]');
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = thumb.getAttribute('data-full');
      main.alt = thumb.getAttribute('data-alt') || main.alt;
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  /* ---------- quantity ---------- */

  document.querySelectorAll('.quantity-control').forEach(function (control) {
    var input = control.querySelector('[data-qty-input]');
    if (!input) return;
    control.addEventListener('click', function (event) {
      var el = event.target.closest('[data-qty-up],[data-qty-down]');
      if (!el) return;
      var value = parseInt(input.value, 10) || 1;
      input.value = el.hasAttribute('data-qty-up') ? value + 1 : Math.max(1, value - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- variant picker ---------- */

  (function () {
    var dataEl = document.querySelector('[data-variant-data]');
    var form = document.getElementById('product-form');
    if (!dataEl || !form) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('[data-variant-input]');
    var addButton = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-price]');
    var selects = Array.prototype.slice.call(form.querySelectorAll('[data-variant-option]'));

    function money(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      return (cents / 100).toFixed(2);
    }

    function update() {
      var chosen = selects.map(function (s) {
        return s.value;
      });
      var match = variants.find(function (v) {
        return chosen.every(function (value, i) {
          return v.options[i] === value;
        });
      });
      if (!match) return;

      idInput.value = match.id;
      if (addButton) {
        addButton.disabled = !match.available;
        addButton.textContent = match.available
          ? addButton.getAttribute('data-add-text') || addButton.textContent
          : 'Sold out';
      }
      if (priceEl && match.price > 0) {
        var html = '<span class="product-price-current">' + money(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<s class="product-price-was">' + money(match.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }
    }

    selects.forEach(function (s) {
      s.addEventListener('change', update);
    });
  })();

  /* ---------- add to cart ---------- */

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  var productForm = document.getElementById('product-form');
  if (productForm) {
    var status = productForm.querySelector('[data-add-status]');
    var defaultNote = status ? status.textContent : '';

    productForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = productForm.querySelector('[data-add-button]');
      var original = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(productForm)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          setCartCount(cart.item_count);
          if (button) button.textContent = 'Added to bag';
          if (status) status.textContent = 'Added. View your bag to check out.';
          setTimeout(function () {
            if (button) {
              button.textContent = original;
              button.disabled = false;
            }
            if (status) status.textContent = defaultNote;
          }, 2600);
        })
        .catch(function () {
          if (status) status.textContent = 'Could not add that just now — please try again.';
          if (button) {
            button.textContent = original;
            button.disabled = false;
          }
        });
    });
  }

  /* ---------- cart line quantities ---------- */

  document.querySelectorAll('[data-cart-line-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      form.submit();
    });
  });
})();
